import { defineManifest } from "@tc/sdk";
export const manifest = defineManifest({
    id: "tasks",
    name: "Tasks",
    version: "0.1.0",
    tier: "core",
    accent: "brand",
    description: "Everything someone has to do, from every module and from managers, in one list per person, the menu badge and the bar at the top of every page.",
    permissions: {
        view: "See and sign off my tasks",
        create: "Set tasks for sites and people",
        manage: "Manage tasks: every site's tasks, task types, routing, groups, schedules and escalations",
        checks: "Set up site checks (fire alarm tests, temperatures…) and see every site's log book",
    },
    tasks: [
        { key: "check", title: "Site checks", description: "Routine checks with a checklist (fire alarm test, temperatures…), done from the phone and recorded in the site's log book. Overdue once past its due day.", icon: "shield", sort: 205, link: "/tasks/checks" },
        { key: "check-failed", title: "Failed checks", description: "Something failed on a site check (and there's no maintenance job for it). Sign off once it's put right.", icon: "alert", sort: 206, link: "/tasks/checks" },
        { key: "system", title: "Needs fixing in the system", description: "From the system's own checks every 5 minutes: a login that stopped working, figures that stopped arriving, a module that isn't working. Clears itself once fixed.", audience: "routed", clear: "fix", icon: "alert", sort: 190 },
    ],
    widgets: [
        { key: "mine", title: "My tasks", description: "What you need to do, urgent first.", group: "Jobs", size: 1, permission: "view", defaultOn: true, order: 5, live: true },
        { key: "checks", title: "Site checks", description: "Fire, food and safety checks: done on time, missed and failed, by site.", group: "Jobs", size: 1, permission: "view", defaultOn: true, order: 6 },
    ],
    nav: [
        { label: "Tasks", path: "/tasks", section: "operations", tab: "Tasks", tabIcon: "tasks", permission: "view", icon: "tasks", order: 2, blurb: "Everything you have to do, from every module and manager" },
        { label: "Site checks", path: "/tasks/checks", section: "operations", tab: "Tasks", tabIcon: "tasks", permission: "view", icon: "shield", order: 3, blurb: "Fire alarm tests, temperatures and each site's log book" },
        { label: "Manage tasks", path: "/tasks/manage", section: "operations", kind: "settings", permission: "manage", icon: "settings", order: 960, blurb: "Task types, routing, groups, schedules and escalations" },
    ],
    grants: {
        "Head office": ["view", "create", "checks", "manage"],
        "Area manager": ["view", "create", "checks"],
        "Site manager": ["view", "create"],
        Supervisor: ["view"],
        Staff: ["view"],
    },
});
